function ConfirmationPopup(settings = {}){
	this.className = "ConfirmationPopup";

	this.name = "confirmation";

	// don't force to be 80% height, too big!
	//settings.autoHeight = true; // not working quite yet, might need to fiddle with this in a similar way as did with patently

	var submissionURLQueryString = '';

	this.data = {
		pages: [{
			title: 	"Confirmation",
			name: 	"confirmation",
			submissionUrl: "/forms/?" + submissionURLQueryString,
			static:	true,
			onRender: $wrapper => {},
			init: () => {
				console.log(this);
				const $wrapper = this.$content;

				const r = this.values;
				const $yesButton = $wrapper.find(".js-button-yes");
				const $noButton  = $wrapper.find(".js-button-no");

				// Close popup on button click
				$yesButton.on('click touchstart', (e) => {
					e.preventDefault();
					if(this.values.onCallback) {
						this.values.onCallback(true, this);
					} else {
						this.cancel();
					}
				});

				// Close popup on button click
				$noButton.on('click touchstart', (e) => {
					e.preventDefault();
					if(this.values.onCallback) {
						this.values.onCallback(false, this);
					} else {
						this.cancel();
					}
				});
			}
		}]
	}

	this.setup(settings);
};
ConfirmationPopup.inheritsFrom( PopupForm );
